query PurchasesList(
  $page: Int
  $rowsPerPage: Int
  $filter: ProductPurchasesFilterInput
) {
  productPurchases(page: $page, rowsPerPage: $rowsPerPage, filter: $filter) {
    count
    nodes {
      id
      type
      startAt
      expiredAt
      refunded
      disputed
      buyerEmail
      userId
      linkReward {
        value
        currency
      }
      product {
        id
        title
      }
      payment {
        id
        amount {
          value
          currency
        }
        amountInOrganizationCurrency {
          value
          currency
        }
        providerFeeAmount {
          value
          currency
        }
        ottkitFeeAmount {
          value
          currency
        }
        organizationAmount {
          value
          currency
        }
        organizationAmountInOrganizationCurrency {
          value
          currency
        }
        provider
        period
        recurrent
        createdAt
        refunds {
          id
          status
          manual
          createdAt
          amount {
            value
            currency
          }
        }
      }
      subscription {
        id
        status
        renewSubscription
        billingCyclesComplete
        renewAttempts
        nextRenewAttemptAt
        renewErrorReason
        renewDeadlineAt
      }
    }
  }
}
